<template>
  <div v-loading="loading">
    <div class="rj-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ name: 'RemittanceList' }">
          电汇查询
        </el-breadcrumb-item>
        <el-breadcrumb-item>款项分配</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="rj-page-card">
      <div class="rj-page-card__title">
        电汇底单信息
      </div>
      <div class="rj-page-card__content">
        <div class="rj-row">
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                电汇编号：
              </div>
              <div class="rj-baseinfo__item">
                {{ telegraphicTransfer.telegraphicTransferNum }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                汇入公司：
              </div>
              <div class="rj-baseinfo__item">
                {{ telegraphicTransfer.accountCompany }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                币种：
              </div>
              <div class="rj-baseinfo__item">
                人民币
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                代理名称：
              </div>
              <div v-if="telegraphicTransfer.newImportCompany" class="rj-baseinfo__item">
                {{ telegraphicTransfer.newImportCompany }}
              </div>
              <div v-else class="rj-baseinfo__item">
                {{ telegraphicTransfer.importCompany }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                汇款日期：
              </div>
              <div class="rj-baseinfo__item">
                {{ telegraphicTransfer.remittanceDate }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                汇款金额：
              </div>
              <div class="rj-baseinfo__item">
                {{ telegraphicTransfer.remittanceAmount }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                汇入银行：
              </div>
              <div class="rj-baseinfo__item">
                {{ telegraphicTransfer.importBank }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                汇入账户：
              </div>
              <div class="rj-baseinfo__item">
                {{ telegraphicTransfer.account }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                备注：
              </div>
              <div class="rj-baseinfo__item">
                {{ telegraphicTransfer.summary }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                可用金额：
              </div>
              <div class="rj-baseinfo__item">
                {{ avUsedAmount }}元
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /未知逻辑 暂不改动 不拆分组件 -->
    <rj-tabs v-model="tabsActive">
      <rj-tab-pane name="1" label="合同">
        <div class="rj-page-card">
          <div class="search-flex">
            <div class="rj-page-card__title">
              款项分配
            </div>
            <div>
              <el-form :inline="true" :model="searchForm" class="demo-form-inline">
                <el-form-item label="合同编号:">
                  <el-input v-model="searchForm.contractNum" placeholder="请输入合同编号" @blur="searchForm.contractNum = (searchForm.contractNum || '').trim()" />
                </el-form-item>
                <el-form-item label="项目名称:">
                  <el-input v-model="searchForm.projectName" placeholder="请输入项目名称" />
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="onSubmit">
                    搜索
                  </el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
          <div class="rj-page-card__content">
            <el-table ref="multipleTable" v-loading="tableLoading" :data="tableData" border style="width: 100%;margin-top: 20px" height="300" @select-all="selectAll" @select="select">
              <el-table-column
                type="selection"
                width="55"
              />
              <el-table-column type="index" width="60" label="序号" align="left" />
              <el-table-column prop="contractNum" label="合同号" align="left" />
              <el-table-column prop="projectName" label="项目名称" align="left" />
              <el-table-column prop="actualSettlementAmount" label="实际结算金额" align="right" header-align="left" />
              <el-table-column prop="borrowPrice" label="冲销金额" align="right" header-align="left" />
              <el-table-column label="预付款金额/比例" align="right" header-align="left">
                <template v-slot="{row}">
                  <span>{{ row.prepaymentRatioAndAmountStr }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="proportion" label="已分配金额/比例" align="right" header-align="left">
                <template v-slot="{row}">
                  <span>{{ row.assignAll }}/{{ Number(row.proportion * 100) }}%</span>
                </template>
              </el-table-column>
              <el-table-column prop="unassign" label="未分配金额" align="right" header-align="left" />
              <el-table-column prop="thisAssign" label="本次分配金额" align="right" header-align="left" width="150">
                <template v-slot="{row}">
                  <el-input-number v-model.number="row.thisAssign" :disabled="row.isSelect" style="width:100%;" :min="0" :precision="2" :max="(row.unassign)*1" label="描述文字" :controls="false" @change="assignBlur(row)" @blur="assignBlur(row)" />
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </rj-tab-pane>
      <rj-tab-pane name="2" label="分批发货申请单">
        <div class="rj-page-card">
          <div class="search-flex">
            <div>
              <el-form :inline="true" :model="searchFormBatch" class="demo-form-inline">
                <el-form-item label="分批申请单号:">
                  <el-input v-model="searchFormBatch.deliveryNum" placeholder="请输入分批申请单号" />
                </el-form-item>
                <el-form-item label="合同编号:">
                  <el-input v-model="searchFormBatch.masterContractNum" placeholder="请输入合同编号" />
                </el-form-item>
                <el-form-item label="项目名称:">
                  <el-input v-model="searchFormBatch.masterProjectName" placeholder="请输入项目名称" />
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="onSubmitBatch">
                    搜索
                  </el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
          <div class="rj-page-card__content">
            <el-table ref="multipleTableBatch" v-loading="tableLoading" :data="tableDataBatch" border style="width: 100%;margin-top: 20px" height="300" @select-all="selectAllBatch" @select="selectBatch">
              <el-table-column
                type="selection"
                width="55"
              />
              <el-table-column type="index" width="60" label="序号" align="left" />
              <el-table-column prop="deliveryNum" label="分批申请单号" align="left" />
              <el-table-column prop="masterContractNum" label="合同号" align="left" />
              <el-table-column prop="masterProjectName" label="项目名称" align="left" />
              <el-table-column prop="amountSum" label="分批发货金额" align="right" header-align="left" />
              <el-table-column prop="assignAll" label="已分配金额" align="right" header-align="left" />
              <!-- <el-table-column prop="proportion" label="已分配金额/比例" align="left">
                <template v-slot="{row}">
                  <span>{{ row.assignAll }}/{{ Number(row.proportion*100).toFixed(2) }}%</span>
                </template>
              </el-table-column> -->
              <el-table-column prop="unassign" label="未分配金额" align="right" header-align="left" />
              <el-table-column prop="thisAssign" label="本次分配金额" align="right" header-align="left" width="150">
                <template v-slot="{row}">
                  <el-input-number v-model.number="row.thisAssign" :disabled="row.isSelect" style="width:100%;" :min="0" :precision="2" :max="(row.unassign)*1" label="描述文字" :controls="false" @change="assignBlurBatch(row)" @blur="assignBlurBatch(row)" />
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </rj-tab-pane>
    </rj-tabs>
    <div class="rj-page-card_btn">
      <el-button type="primary" :loading="isSubmit" @click="confirmAllocation">
        确认分配
      </el-button>
      <div style="color: #606266;height: 41px;line-height: 41px;display: inline-block;margin-left: 20px">
        <div>本次分配总和：<span class="money">{{ assignAllTotal }} 元</span></div>
      </div>
    </div>
    <distributionBatch :dialogdistribution-batch="dialogdistributionBatch" :telegraphic-transfer-num="telegraphicTransfer.telegraphicTransferNum" :table-data-batch-dlaoig="tableDataBatchDlaoig" @status="status" @on-status-dialog="onBatchDialog" />
    <el-dialog
      title="确认分配"
      :visible.sync="dialogVisible"
      width="900px"
      top="15px"
      @close="close"
    >
      <span class="dialogVisibleClolr">注：首付款金额差异不为0的，需要分配足额首付款，否则会影响下单</span>
      <el-table :data="dialogData" border style="width: 100%" :summary-method="getSummaries" show-summary>
        <el-table-column type="index" width="60" label="序号" align="left" fixed="left" />
        <el-table-column prop="contractNum" label="合同号" align="left" fixed="left" />
        <el-table-column prop="projectName" label="项目名称" align="left" />
        <el-table-column prop="prepaymentAmountStr" label="预付款金额" align="right" header-align="left" />
        <el-table-column prop="borrowPrice" label="冲销金额" align="right" header-align="left" />
        <el-table-column prop="actualSettlementAmount" label="订单金额" align="right" header-align="left" />
        <el-table-column prop="thisAssign" label="本次分配金额" align="right" header-align="left" />
        <el-table-column label="首付款差异金额" align="right" header-align="left">
          <template v-slot="{row}">
            <span>{{ (row.prepaymentAmountStr+row.borrowPrice - row.assignAll - row.thisAssign) >0?(row.prepaymentAmountStr+row.borrowPrice - row.assignAll - row.thisAssign).toFixed(2) : 0 }}</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="footer-btn">
        <el-button type="default" @click="cancel">
          取消
        </el-button>
        <el-button type="primary" :loading="isSubmitHt" style="margin-top:10px" @click="sureAction">
          确认分配
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script type="es6">
import tabs from '@/components/Tabs/tabs';
import tabPane from '@/components/Tabs/tabPane';
import distributionBatch from './components/distributionBatch';
import { selectModelByTelegraphicTransferNum, remittanceAssignToContractAmount, getContractAssignInfoListByTeleAndOrderUnit, getPartialOrderWithNoAssignData } from '@/API/index';
import { MathAdd, Subtr } from '@/libs/util';

export default {
  data () {
    return {
      searchForm: {
        contractNum: '',
        projectName: ''
      },
      searchFormBatch: {
        deliveryNum: '',
        masterContractNum: '',
        masterProjectName: ''
      },
      dialogVisible: false,
      dialogData: [],
      tableData: [], // 合同数据
      tableDataBatch: [], // 分批发货数据
      loading: false,
      orderUnit: this.$route.params.orderUnit, // 路由信息
      telegraphicTransfer: [], // base 数据
      businessEntity: '',
      teleTransferNum: this.$route.params.teleNum,
      isSubmit: false, // 合同提交loading
      isSubmitHt: false, // 分批发货提交loading
      totalAmount: '',
      multipleSelection: [], // 合同勾选集合
      multipleSelectionBatch: [], // 分批发货勾选集合
      tableLoading: false,
      tabsActive: '1',
      // 分配dialog
      dialogdistributionBatch: false, // 合同分配确认弹框
      tableDataBatchDlaoig: [], // 分批发货分配确认
      contractAssignList: []
    };
  },
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  components: {
    'rj-tab-pane': tabPane,
    'rj-tabs': tabs,
    distributionBatch
  },
  computed: {
    avUsedAmount () {
      let totalAccount = 0;
      if (this.tabsActive === '1') {
        this.tableData.forEach((item) => {
          totalAccount = MathAdd(totalAccount, item.thisAssign);
        });
      } else {
        this.tableDataBatch.forEach((item) => {
          totalAccount = MathAdd(totalAccount, item.thisAssign);
        });
      }
      let unused = this.telegraphicTransfer.unusedAmount == null ? 0 : this.telegraphicTransfer.unusedAmount;
      return Subtr(unused, totalAccount);
    },
    assignAllTotal () {
      let total = 0;
      if (this.tabsActive === '1') {
        this.tableData.forEach((item) => {
          total = MathAdd(item.thisAssign ? item.thisAssign : 0, total);
        });
      } else {
        this.tableDataBatch.forEach((item) => {
          total = MathAdd(item.thisAssign ? item.thisAssign : 0, total);
        });
      }

      return total;
    }
  },
  methods: {
    getAssignInfo () {
      this.tableLoading = true;
      let params = {
        teleNum: this.teleTransferNum,
        contractNum: this.searchForm.contractNum,
        projectName: this.searchForm.projectName
      };
      getContractAssignInfoListByTeleAndOrderUnit(params).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.tableLoading = false;
          json.data.forEach((item) => {
            item.isSelect = true;
          });
          this.tableData = json.data;
        }
      }).catch((res) => {
        this.tableLoading = false;
      });
    },
    getAssignInfoBatch () {
      let params = {
        bussinessEntity: this.bussinessEntity,
        telegraphicTransferNum: this.telegraphicTransfer.telegraphicTransferNum,
        deliveryNum: this.searchFormBatch.deliveryNum,
        masterContractNum: this.searchFormBatch.masterContractNum,
        masterProjectName: this.searchFormBatch.masterProjectName
      };
      getPartialOrderWithNoAssignData(params).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          json.data.forEach((item) => {
            item.isSelect = true;
            this.$set(item, 'thisAssign', '');
          });
          this.tableDataBatch = json.data;
          // 增加数据 未分配金额
          this.tableDataBatch.forEach((item) => {
            item.unassign = (item.amountSum - item.assignAll).toFixed(2);
          });
        }
      }).catch((res) => {
        // this.tableLoading = false;
      });
    },
    telegraphic () {
      selectModelByTelegraphicTransferNum(this.teleTransferNum).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.bussinessEntity = json.data.bussinessEntity;
          this.telegraphicTransfer = json.data.telegraphicTransfer;
          this.totalAmount = json.data.telegraphicTransfer.unusedAmount;
          // TODO;
          this.getAssignInfoBatch();
        }
      }).catch((res) => {
        console.log(res);
      });
    },
    assignBlur (row) {
      if (row.thisAssign === undefined) {
        row.thisAssign = 0;
      }
      if (row.thisAssign > row.unassign) {
        row.thisAssign = row.unassign;
      }
      let num = 0;
      this.tableData.forEach((item) => {
        if (item.thisAssign > 0) {
          num = MathAdd(num, item.thisAssign);
        }
      });
      if (this.totalAmount >= num) {
        this.isSubmit = false;
      } else {
        this.isSubmit = true;
        this.$message.warning('本次分配金额不能大于可用金额');
        row.thisAssign = 1;
        this.$nextTick(() => {
          row.thisAssign = 0;
        });
      }
    },
    // 分批发货
    assignBlurBatch (row) {
      if (row.thisAssign === undefined) {
        row.thisAssign = 0;
      }
      if (row.thisAssign > row.unassign) {
        row.thisAssign = row.unassign;
      }
      let num = 0;
      this.tableDataBatch.forEach((item) => {
        if (item.thisAssign > 0) {
          num = MathAdd(num, item.thisAssign);
        }
      });
      if (this.totalAmount >= num) {
        this.isSubmit = false;
      } else {
        this.isSubmit = false;
        this.$message.warning('本次分配金额不能大于可用金额');
        row.thisAssign = 1;
        this.$nextTick(() => {
          row.thisAssign = 0;
        });
      }
    },
    // onBatchDialog
    onBatchDialog (val) {
      this.dialogdistributionBatch = val;
    },
    status (val) {
      this.$message.success('分配成功');
      this.$router.go(-1);
    },
    close () {
      this.dialogVisible = false;
      this.dialogData = [];
      this.isSubmit = false;
      this.isSubmitHt = false;
      this.contractAssignList = [];
    },
    // 合计
    getSummaries (param) {
      const { columns } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (column.label === '本次分配金额') {
          sums[index] = this.allAmount();
        }
      });
      return sums;
    },
    // 实际结算金额总计
    allAmount () {
      let cont = 0;
      this.dialogData.forEach((item) => {
        cont = MathAdd(cont, item.thisAssign);
      });
      cont = Number(cont).toFixed(2);
      return cont;
    },
    confirmAllocation () {
      this.isSubmit = true;
      if (this.tabsActive === '2') {
        this.isSubmit = false;
        // dialog 页面
        this.tableDataBatchDlaoig = this.multipleSelectionBatch;
        this.dialogdistributionBatch = true;
      } else {
        // this.dialogVisible = true;
        let totalNum = 0;
        this.tableData.forEach((item) => {
          totalNum = totalNum + item.thisAssign;
        });
        if (totalNum <= 0) {
          this.$alert('分配框的值不能为0', '确认分配', {
            confirmButtonText: '确定'
          });
          this.isSubmit = false;
        } else {
          if (this.multipleSelection.length > 0) {
            // let contractAssignList = [];
            this.multipleSelection.forEach((items) => {
              this.tableData.forEach((item) => {
                if (items.contractNum === item.contractNum) {
                  let ls = {};
                  if (item.thisAssign > 0) {
                    ls.id = item.id;
                    ls.contractNum = item.contractNum;
                    ls.assignAmount = item.thisAssign;
                    this.contractAssignList.push(ls);
                  }
                }
              });
            });
            if (this.contractAssignList.length === 0) {
              this.$notify.warning('至少勾选一条记录');
              this.isSubmit = false;
            }
            this.dialogVisible = true;
            this.dialogData = this.multipleSelection;
          } else {
            this.$notify.warning('只能提交勾选过的分配数据');
            this.isSubmit = false;
          }
        }
      }
    },
    sureAction () {
      this.getApi();
    },
    cancel () {
      this.close();
    },
    getApi () {
      let params = {
        telegraphicTransferNum: this.telegraphicTransfer.telegraphicTransferNum,
        contractAssignListVOList: this.contractAssignList,
        businessEntity: this.telegraphicTransfer.bussinessEntity
      };
      this.isSubmitHt = true;
      remittanceAssignToContractAmount(params).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.$message.success('分配成功');
          this.$router.go(-1);
          this.isSubmitHt = false;
        }
        this.isSubmitHt = false;
      }).catch((res) => {
        this.isSubmitHt = false;
      });
    },
    selectAll (selection) {
      // console.log(selection);
      let error = '';
      let totalAssign = 0;
      this.tableData.forEach((items) => {
        items.isSelect = true;
        selection.forEach((item) => {
          if (item === items) {
            item.isSelect = false;
            if (item.thisAssign === 0) {
              item.thisAssign = item.unassign;
            }
          }
        });
      });
      this.tableData.forEach((item) => {
        totalAssign = MathAdd(totalAssign, item.thisAssign);
        if (this.telegraphicTransfer.unusedAmount < totalAssign) {
          this.$refs.multipleTable.toggleRowSelection(item, false);
          item.isSelect = true;
          item.thisAssign = 0;
          error = '本次分配金额不能大于可用金额';
        }
      });
      this.tableData.forEach((item) => {
        if (item.isSelect) {
          item.thisAssign = 0;
        }
      });
      if (error) {
        this.$notify.warning(error);
        this.tableData.forEach((item) => {
          if (!item.isSelect) {
            this.multipleSelection.push(item);
          }
        });
        console.log(this.multipleSelection);
        return false;
      }
      this.multipleSelection = selection;
    },
    // 分批全选
    selectAllBatch (selection) {
      // console.log(selection);
      let error = '';
      let totalAssign = 0;
      this.tableDataBatch.forEach((items) => {
        items.isSelect = true;
        selection.forEach((item) => {
          if (item === items) {
            item.isSelect = false;
            if (item.thisAssign === 0) {
              item.thisAssign = item.unassign;
            }
          }
        });
      });
      this.tableDataBatch.forEach((item) => {
        totalAssign = MathAdd(totalAssign, item.thisAssign);
        if (this.telegraphicTransfer.unusedAmount < totalAssign) {
          this.$refs.multipleTableBatch.toggleRowSelection(item, false);
          item.isSelect = true;
          item.thisAssign = 0;
          error = '本次分配金额不能大于可用金额';
        }
      });
      this.tableDataBatch.forEach((item) => {
        if (item.isSelect) {
          item.thisAssign = 0;
        }
      });
      if (error) {
        this.$notify.warning(error);
        this.tableDataBatch.forEach((item) => {
          if (!item.isSelect) {
            this.multipleSelectionBatch.push(item);
          }
        });
        return false;
      }
      this.multipleSelectionBatch = selection;
    },
    select (selection, row) {
      let error = '';
      if (row.isSelect) {
        row.isSelect = false;
      } else {
        row.isSelect = true;
      }
      if (row.thisAssign === 0 && row.unassign < this.avUsedAmount) {
        row.thisAssign = row.unassign;
      } else {
        if (this.avUsedAmount <= 0 && !row.isSelect) {
          this.$refs.multipleTable.toggleRowSelection(row, false);
          row.isSelect = true;
          row.thisAssign = 0;
          error = '可用余额已为0';
        }
        row.thisAssign = this.avUsedAmount;
      }
      if (row.isSelect) {
        row.thisAssign = 0;
      }
      if (error) {
        this.$notify.warning(error);
        return false;
      }
      this.multipleSelection = selection;
    },
    // 勾选 分批
    selectBatch (selection, row) {
      let error = '';
      if (row.isSelect) {
        row.isSelect = false;
      } else {
        row.isSelect = true;
      }
      if (row.thisAssign === 0 && row.unassign * 1 < this.avUsedAmount * 1) {
        row.thisAssign = row.unassign;
      } else {
        if (this.avUsedAmount <= 0 && !row.isSelect) {
          this.$refs.multipleTableBatch.toggleRowSelection(row, false);
          row.isSelect = true;
          row.thisAssign = 0;
          error = '可用余额已为0';
        }
        row.thisAssign = this.avUsedAmount;
      }
      if (row.isSelect) {
        row.thisAssign = 0;
      }
      if (error) {
        this.$notify.warning(error);
        return false;
      }
      this.multipleSelectionBatch = selection;
    },
    onSubmit () {
      this.getAssignInfo();
    },
    onSubmitBatch () {
      this.getAssignInfoBatch();
    }
  },
  mounted () {
    this.telegraphic();
    this.getAssignInfo();
  }
};
</script>
<style lang="scss">
  .rj-page-card_btn{
    margin-top: 20px;
  }
   .dialogVisibleClolr{
      color: red;
      display: inline-block;
      margin-bottom: 10px;
    }
  .search-flex{
    display: flex;
    .rj-page-card__title{
      margin-right: 40px;
    }
  }
</style>

<style scoped>
.footer-btn{
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}
</style>
